import { getMetaOSInstalledApps } from 'appservices-utils';
import { getApolloClient } from 'owa-apollo';
import { getOrigin, ensureTrailingSlash } from 'owa-url';
import * as Schema from 'owa-graph-schema';
import { AppDefinitionDataDocument } from './graphql/queries/__generated__/appDefinitionQuery.interface';
import { log } from './telemetry';

let appDefinitionsMap: { [key: string]: Schema.AppDefinition };
let requestTeamsMtCount = 0;

export function getStaticAppDefinitionsMap() {
    if (!appDefinitionsMap) {
        appDefinitionsMap = {};

        appDefinitionsMap['com.example.metaostestapp.test'] = {
            accentColor: '#006600',
            id: 'com.example.metaostestapp.test',
            developerName: 'Microsoft Teams Ecosystem',
            developerUrl: 'https://www.example.com',
            privacyUrl: 'https://www.example.com',
            termsOfUseUrl: 'https://www.example.com',
            galleryTabs: [
                {
                    configurationUrl: 'https://cloudroll.azurewebsites.net/',
                },
            ],
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/test_largeimage.png?v=0.1',
            longDescription: 'Full app-sdk capabilities test app',
            name: 'Test',
            staticTabs: [
                {
                    contentUrl: 'https://cloudroll.azurewebsites.net/',
                    websiteUrl: 'https://cloudroll.azurewebsites.net/',
                    entityId: 'test',
                    name: 'Test',
                },
            ],
            validDomains: ['*tab.azurewebsites.net', 'cloudroll.azurewebsites.net'],
            shortDescription: 'Test',
            showLoadingIndicator: true,
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/test_smallimage.png?v=0.1',
            webApplicationInfo: {
                id: '34d8e67c-2758-40b5-836f-eb7defa875d3',
                resource: 'api://cloudroll.azurewebsites.net/34d8e67c-2758-40b5-836f-eb7defa875d3',
            },
            version: '0.0.0',
        };
        appDefinitionsMap['db5e5970-212f-477f-a3fc-2227dc7782bf'] = {
            id: 'db5e5970-212f-477f-a3fc-2227dc7782bf',
            showLoadingIndicator: true,
            accentColor: '#093c7f',
            activities: {
                activityItems: [
                    {
                        description: 'Announcements',
                        templateText: '{actor} posted an announcement',
                        type: 'announcementCreated',
                    },
                    {
                        description: '@mentions',
                        templateText: '{actor} mentioned you',
                        type: 'userMention',
                    },
                ],
            },
            categories: ['Microsoft'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.yammer.com',
            galleryTabs: [
                {
                    canUpdateConfiguration: true,
                    configurationUrl: 'https://teams.yammer.com/configure?client=outlook',
                    scopes: ['team'],
                },
            ],
            isFullTrust: false,
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/955070e9-99a6-4319-b8df-32adf59949aa_largeImage.png?v=2.1.1',
            longDescription:
                'Add a fully-interactive Yammer experience to Microsoft Teams. Yammer communities connect the organization, enabling you to engage with leaders, watch live events, and stay up-to-date with news and announcements. Communities also enable people to share knowledge, ask questions, get answers, and build relationships across teams and organizational silos. Add the Yammer app and pin it to the navigation rail. It’s Yammer—in Teams.',
            manifestVersion: 'devPreview',
            name: 'Communities (Dogfood)',
            permissions: [],
            privacyUrl: 'https://go.microsoft.com/fwlink/p/?linkid=857875',
            shortDescription: 'Drive engagement in your organization through Yammer communities.',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/955070e9-99a6-4319-b8df-32adf59949aa_smallImage.png?v=2.1.1',
            staticTabs: [
                {
                    contentUrl: 'https://web.yammer.com/teams/feed?client=outlook',
                    entityId: '1',
                    name: 'Yammer',
                    scopes: ['Personal'],
                    websiteUrl: 'https://www.yammer.com',
                },
            ],
            termsOfUseUrl: 'https://aka.ms/yammer-teams-tos',
            validDomains: ['teams.yammer.com', 'web.yammer.com', 'www.yammer.com'],
            version: '2.1.1',
            webApplicationInfo: {
                id: '00000005-0000-0ff1-ce00-000000000000',
                resource: 'https://web.yammer.com/teams',
            },
        };

        appDefinitionsMap['4c4ec2e8-4a2c-4bce-8d8f-00fc664a4e5b'] = {
            id: '4c4ec2e8-4a2c-4bce-8d8f-00fc664a4e5b',
            showLoadingIndicator: false,
            accentColor: '#60A18E',
            categories: ['Microsoft', 'Productivity'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            isFullTrust: false,
            largeImageUrl:
                'https://statics.teams.microsoft.com/evergreen-assets/apps/customer_scheduler_largeimage.png?v=1.0.3',
            longDescription:
                'Enables professionals and administrators to schedule bookings with Microsoft Teams Meetings. Use this scheduling tool to send appointment reminders from your business or department to meet virtually with any attendee.',
            manifestVersion: '1.3',
            name: 'Bookings',
            permissions: ['Identity'],
            privacyUrl: 'https://www.microsoft.com/privacy',
            shortDescription: 'Schedule bookings between staff and any attendee.',
            smallImageUrl:
                'https://statics.teams.microsoft.com/evergreen-assets/apps/customer_scheduler_smallimage.png?v=1.0.3',

            staticTabs: [
                {
                    contentUrl:
                        'https://healthcare.teams.microsoft.com:443/scheduler-web?theme={theme}&hubName=outlook',
                    entityId: 'Consults',
                    name: 'Bookings',
                    scopes: ['Personal'],
                },
            ],

            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            validDomains: ['*.microsoft.com'],
            version: '1.0.4',

            webApplicationInfo: {
                id: '4c4ec2e8-4a2c-4bce-8d8f-00fc664a4e5b',
                resource: 'https://healthcare.teams.microsoft.com',
            },
        };

        appDefinitionsMap['0d5c91ee-5be2-4b79-81ed-23e6c4580427'] = {
            accentColor: '#FFFFFF',
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            privacyUrl: 'https://www.microsoft.com/privacy',
            devicePermissions: ['notifications'],
            id: '0d5c91ee-5be2-4b79-81ed-23e6c4580427',
            largeImageUrl:
                'https://owaprod.blob.core.windows.net/todo/publicIcons/todo-metaos-192.png',
            name: 'To Do',
            version: '1.0.0',
            showLoadingIndicator: false,
            smallImageUrl:
                'https://owaprod.blob.core.windows.net/todo/publicIcons/todo-metaos-32.png',
            staticTabs: [
                {
                    contentUrl: 'https://outlook.office.com/tasks?app&hostApp=metaOSHub',
                    entityId: 'ToDoId',
                    name: 'To Do',
                    scopes: ['Personal'],
                },
            ],
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            validDomains: ['outlook.office.com,*.office.com,*.microsoft.com'],
            webApplicationInfo: {
                id: '0d5c91ee-5be2-4b79-81ed-23e6c4580427',
                resource: 'https://outlook.office.com/',
            },
        };

        appDefinitionsMap['f3a6e67f-850d-4dd9-960a-04c6638ded36'] = {
            accentColor: '',
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            privacyUrl: 'https://www.microsoft.com/privacy',
            devicePermissions: ['geolocation', 'media', 'midi', 'notifications', 'openExternal'],
            id: 'f3a6e67f-850d-4dd9-960a-04c6638ded36',
            largeImageUrl:
                'https://static2.sharepointonline.com/files/fabric-cdn-prod_20200430.002/assets/brand-icons/product/png/office_48x2.png',
            name: 'App Store',
            version: 'b0.0.2',
            showLoadingIndicator: false,
            smallImageUrl:
                'https://static2.sharepointonline.com/files/fabric-cdn-prod_20200430.002/assets/brand-icons/product/png/office_48x1.png',
            staticTabs: [
                {
                    contentUrl:
                        'https://teams.microsoft.com/extensibility-apps/store/view?host=metaos&language={locale}&metaoshost={hostName}&clienttype={hostClientType}',
                    entityId: 'browse',
                    name: 'App Store',
                    scopes: ['Personal'],
                },
            ],
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            validDomains: ['*.teams.microsoft.com', '*.teams.office.com'],
            webApplicationInfo: {
                id: 'f3a6e67f-850d-4dd9-960a-04c6638ded36',
                resource: 'https://teams.microsoft.com',
            },
        };

        const origin = getOrigin();
        appDefinitionsMap['9b049ed6-fc8b-40c7-815b-bf84e344d270'] = {
            name: 'Org Explorer',
            id: '9b049ed6-fc8b-40c7-815b-bf84e344d270',
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            privacyUrl: 'https://www.microsoft.com/privacy',
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            largeImageUrl: '',
            version: 'b0.0.5',
            galleryTabs: [
                {
                    configurationUrl: `${origin}/orgexplorer/{userPrincipalName}/?hostApp=hub&isanonymous=true`,
                },
            ],
            staticTabs: [
                {
                    contentUrl: `${origin}/orgexplorer/{userPrincipalName}/?hostApp=hub&isanonymous=true`,
                },
            ],
            validDomains: [
                '*.office.com',
                '*.office.net',
                '*.office365.com',
                '*.microsoft.com',
                '*.akamaihd.net',
            ],
            showLoadingIndicator: true,
            isFullTrust: false,
            webApplicationInfo: {
                id: '0d5c91ee-5be2-4b79-81ed-23e6c4580427',
                resource: ensureTrailingSlash(origin),
            },
        };
        appDefinitionsMap['com.microsoft.teamspace.tab.youtube'] = {
            manifestVersion: 'devPreview',
            version: '1.0.0',
            categories: ['ImageAndVideoGalleries', 'Social'],
            developerName: 'Microsoft Teams Ecosystem',
            developerUrl: 'https://www.youtube.com',
            privacyUrl: 'https://www.youtube.com',
            termsOfUseUrl: 'https://www.youtube.com',
            validDomains: ['tabs.teams.microsoft.com', '*.youtube.com', 'youtu.be'],
            galleryTabs: [
                {
                    configurationUrl: 'https://tabs.teams.microsoft.com/youtube',
                    scopes: ['Team', 'GroupChat'],
                },
            ],
            inputExtensions: [
                {
                    botId: 'e8cc5e39-5f09-4f70-8640-b40e1c39e84b',
                    scopes: ['Personal', 'Team'],
                    commands: [
                        {
                            id: 'search.Youtube',
                            parameters: [
                                {
                                    name: 'keyword',
                                    title: 'Search term',
                                    description: 'Enter a search term',
                                },
                            ],
                            title: 'Browse YouTube',
                            description: 'Browse YouTube for videos',
                        },
                    ],
                    messageHandlers: [
                        {
                            value: {
                                domains: ['*.youtube.com', 'youtube.com', '*.youtu.be', 'youtu.be'],
                            },
                        },
                    ],
                },
            ],
            showLoadingIndicator: true,
            shortDescription: 'Search for videos on YouTube',
            longDescription:
                'Share a YouTube video with other members of the channel. Simply search for the video you want or paste its URL.',
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/YouTube_largeimage.png?v=0.3',
            accentColor: '#cd2125',
            id: 'com.microsoft.teamspace.tab.youtube',
            name: 'YouTube',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/YouTube_smallimage.png?v=0.3',
            state: 'Installed',
        };
        appDefinitionsMap['4418ab2d-27e1-4b30-a0ac-a88284330faa'] = {
            officeAssetId: 'WA104381597',
            screenshotUrls: [
                'https://statics.teams.cdn.office.net/evergreen-assets/ThirdPartyApps/screenshots/25492237-70ef-4c56-a36e-dd3405edd40e/1.png?v=1.2',
                'https://statics.teams.cdn.office.net/evergreen-assets/ThirdPartyApps/screenshots/25492237-70ef-4c56-a36e-dd3405edd40e/2.png?v=1.2',
                'https://statics.teams.cdn.office.net/evergreen-assets/ThirdPartyApps/screenshots/25492237-70ef-4c56-a36e-dd3405edd40e/3.png?v=1.2',
                'https://statics.teams.cdn.office.net/evergreen-assets/ThirdPartyApps/screenshots/25492237-70ef-4c56-a36e-dd3405edd40e/4.png?v=1.2',
            ],
            manifestVersion: 'devPreview',
            version: '1.2',
            categories: ['Reference', 'LookAndFeel', 'Education'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com/en-us/',
            privacyUrl: 'https://www.microsoft.com/en-us/privacystatement',
            termsOfUseUrl: 'https://www.microsoft.com/en-us/servicesagreement',
            validDomains: ['*.wikipedia.org'],
            permissions: ['Identity', 'MessageTeamMembers'],
            inputExtensions: [
                {
                    botId: 'e4b3068b-8b2e-492a-b06a-8a992cece2cf',
                    scopes: ['Team', 'Personal'],
                    commands: [
                        {
                            id: 'search.Wikipedia',
                            parameters: [
                                {
                                    name: 'searchKeyword',
                                    title: 'Search term',
                                    description: 'Enter a search term',
                                },
                            ],
                            title: 'Browse Wikipedia',
                            description: 'Browse Wikipedia for articles',
                        },
                    ],
                    messageHandlers: [
                        {
                            value: {
                                domains: ['*.wikipedia.org'],
                            },
                        },
                    ],
                },
            ],
            industries: ['Education'],
            lastUpdatedAt: '2021-06-17T08:13:01.1663988+00:00',
            shortDescription: 'Share articles from Wikipedia',
            longDescription:
                'Leverage the power of the services your organization uses directly within Microsoft Teams. Do a quick search for a Wikipedia article and share it in a conversation.',
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/ThirdPartyApps/25492237-70ef-4c56-a36e-dd3405edd40e_largeImage.png?v=1.2',
            accentColor: '#f2f2f2',
            id: '4418ab2d-27e1-4b30-a0ac-a88284330faa',
            name: 'Wikipedia Search',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/ThirdPartyApps/25492237-70ef-4c56-a36e-dd3405edd40e_smallImage.png?v=1.2',
            state: 'Installed',
        };
        appDefinitionsMap['2a22d0b1-431e-49fb-91bf-44ef1bdb890c'] = {
            manifestVersion: 'devPreview',
            version: '1.0',
            categories: ['NewsAndWeather', 'Microsoft'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            privacyUrl: 'https://privacy.microsoft.com/privacystatement',
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            permissions: ['Identity', 'MessageTeamMembers'],
            inputExtensions: [
                {
                    botId: '2a22d0b1-431e-49fb-91bf-44ef1bdb890c',
                    scopes: ['Personal', 'Team'],
                    commands: [
                        {
                            id: 'search.Weather',
                            parameters: [
                                {
                                    name: 'searchKeyword',
                                    title: 'Location',
                                    description: 'Search for a location',
                                },
                            ],
                            title: 'Search',
                            description: 'Enter a city, zip code, or location',
                        },
                    ],
                },
            ],
            shortDescription: 'Get the latest weather report',
            longDescription:
                'Find current weather reports for any city, zip code, or location, then share them in a channel or chat.',
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/Weather_largeimage.png?v=0.3',
            accentColor: '#0378d7',
            id: '2a22d0b1-431e-49fb-91bf-44ef1bdb890c',
            name: 'Weather',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/Weather_smallimage.png?v=0.3',
            state: 'Installed',
        };
        appDefinitionsMap['81e08247-7576-4335-9f83-9904fda708d1'] = {
            manifestVersion: 'devPreview',
            version: '1.0',
            categories: ['Microsoft'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            privacyUrl: 'https://privacy.microsoft.com/privacystatement',
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            permissions: ['Identity', 'MessageTeamMembers'],
            inputExtensions: [
                {
                    botId: '81e08247-7576-4335-9f83-9904fda708d1',
                    scopes: ['Personal', 'Team'],
                    commands: [
                        {
                            id: 'search.Finance',
                            parameters: [
                                {
                                    name: 'searchKeyword',
                                    title: 'searchKeyword',
                                    description: 'Enter a stock symbol',
                                },
                            ],
                            title: 'Search stocks',
                            description: 'Search for stock quotes',
                        },
                    ],
                },
            ],
            shortDescription: 'Get real-time stock quotes',
            longDescription:
                'Get real-time stock quotes and share them in a conversation. Search by company name or stock symbol.',
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/stocks_largeimage.png?v=0.1',
            accentColor: '#3E8548',
            id: '81e08247-7576-4335-9f83-9904fda708d1',
            name: 'Stocks',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/stocks_smallimage.png?v=0.1',
            state: 'Installed',
        };
        appDefinitionsMap['5b6e3100-59fa-49ff-beb5-2ee1a474ba16'] = {
            manifestVersion: 'devPreview',
            version: '1.0',
            categories: ['Microsoft'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.bing.com/maps',
            privacyUrl: 'https://privacy.microsoft.com/PrivacyStatement',
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            validDomains: ['bots.teams.microsoft.com', 'bots.teams.skype.com'],
            permissions: ['Identity', 'MessageTeamMembers'],
            inputExtensions: [
                {
                    botId: '5b6e3100-59fa-49ff-beb5-2ee1a474ba16',
                    canUpdateConfiguration: true,
                    scopes: ['Personal', 'Team'],
                    commands: [
                        {
                            id: 'search.Places',
                            initialRun: true,
                            parameters: [
                                {
                                    name: 'searchKeyword',
                                    title: 'Search',
                                    description: 'Enter a location',
                                },
                            ],
                            title: 'Search places',
                            description: 'Search for a location to get detailed info',
                        },
                    ],
                },
            ],
            shortDescription: 'Get info about different places',
            longDescription:
                'Places lets you look up detailed info about different businesses, restaurants, venues, and more. Find out the address, hours of operation, or reviews for a business, then share them in a conversation.',
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/places/Places_96x96.png?v=0.1',
            accentColor: '#008272',
            id: '5b6e3100-59fa-49ff-beb5-2ee1a474ba16',
            name: 'Places',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/places/Places_smallimage.png?v=0.1',
            state: 'Featured',
        };
        appDefinitionsMap['fe70ef03-7edb-4c23-9a21-75adb92c9942'] = {
            manifestVersion: 'devPreview',
            version: '1.0',
            categories: ['Microsoft'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            privacyUrl: 'https://privacy.microsoft.com/privacystatement',
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            permissions: ['Identity', 'MessageTeamMembers'],
            inputExtensions: [
                {
                    botId: 'fe70ef03-7edb-4c23-9a21-75adb92c9942',
                    scopes: ['Personal', 'Team'],
                    commands: [
                        {
                            id: 'search.Images',
                            parameters: [
                                {
                                    name: 'searchKeyword',
                                    title: 'Keyword',
                                    description: 'Enter a keyword',
                                },
                            ],
                            title: 'Search images',
                            description: 'Enter a keyword to search for an image',
                        },
                    ],
                },
            ],
            shortDescription: 'Find and share images from Bing',
            longDescription:
                'Search Bing for the image you need and share it directly in a channel or chat.',
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/BingImages_largeimage.png?v=0.3',
            accentColor: '#80397B',
            id: 'fe70ef03-7edb-4c23-9a21-75adb92c9942',
            name: 'Images',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/BingImages_smallimage.png?v=0.3',
            state: 'Installed',
        };
        appDefinitionsMap['3d53b9bf-06e9-42df-9bd3-3faa6887b6ae'] = {
            manifestVersion: 'devPreview',
            version: '1.0',
            categories: ['NewsAndWeather', 'Microsoft'],
            developerName: 'Microsoft Corporation',
            developerUrl: 'https://www.microsoft.com',
            privacyUrl: 'https://privacy.microsoft.com/privacystatement',
            termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
            permissions: ['Identity', 'MessageTeamMembers'],
            inputExtensions: [
                {
                    botId: '3d53b9bf-06e9-42df-9bd3-3faa6887b6ae',
                    scopes: ['Personal', 'Team'],
                    commands: [
                        {
                            id: 'search.News',
                            initialRun: true,
                            parameters: [
                                {
                                    name: 'searchKeyword',
                                    title: 'Search term',
                                    description: 'Enter a search term',
                                },
                            ],
                            title: 'Search',
                            description: 'Enter a name, city, event, or keyword',
                        },
                    ],
                },
            ],
            shortDescription: 'Stay on top of the latest news',
            longDescription:
                'Stay up-to-date on current events courtesy of Bing News. Find coverage of local, national, and worldwide news, then share it in a channel.',
            largeImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/News_largeimage.png?v=0.5',
            accentColor: '#D03439',
            id: '3d53b9bf-06e9-42df-9bd3-3faa6887b6ae',
            name: 'News',
            smallImageUrl:
                'https://statics.teams.cdn.office.net/evergreen-assets/apps/News_smallimage.png?v=0.5',
            state: 'Installed',
        };
    }
    return appDefinitionsMap;
}

export async function getAppDefinition(key: string): Promise<Schema.AppDefinition | null> {
    const appDefinitionsMap = getStaticAppDefinitionsMap();

    log({
        appId: key,
        step: 'getAppDefinition',
    });

    if (key in appDefinitionsMap) {
        return Promise.resolve(appDefinitionsMap[key]);
    }

    let appDefinitions: undefined | Array<Schema.AppDefinition>;
    try {
        const apolloClient = getApolloClient();
        const appDefinitionResponse = await apolloClient.query({
            query: AppDefinitionDataDocument,
            variables: {},
            fetchPolicy: 'cache-first',
        });
        appDefinitions = appDefinitionResponse.data?.appDefinitions as
            | undefined
            | Array<Schema.AppDefinition>;
    } catch (err) {
        if (err.message === 'ApolloNotInitialized') {
            // When loading directly through an URL with appId (and other params), routing
            // is initialized first, hence we don't have access to Apollo's infrastructure yet.
            // Temporarily go through this manually caching route until WI 129406 is tackled
            log({
                appId: key,
                step: 'queryAppdefinition',
                context: 'Apollo_Unavailable',
            });
            appDefinitions = await getMetaOSInstalledApps();
            requestTeamsMtCount++;
        }
    } finally {
        if (appDefinitions) {
            for (const definition of appDefinitions) {
                if (definition?.id === key) {
                    return definition;
                }
            }
        }
        log({
            appId: key,
            step: 'queryAppdefinition',
            context: 'ResponseEmpty',
        });
        return null;
    }
}

export function isDataAvailablePriorToApolloInit(): boolean {
    return requestTeamsMtCount > 0;
}

export function addDefinition(definition: Schema.AppDefinition) {
    const appDefinitionsMap = getStaticAppDefinitionsMap();
    if (!appDefinitionsMap[definition.id]) {
        appDefinitionsMap[definition.id] = definition;
    }
}
